import { Link, NavLink, Outlet } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

const nav = [
  { to: "/admin", label: "דשבורד", end: true },
  { to: "/admin/orders", label: "הזמנות" },
  { to: "/admin/payments", label: "תשלומים" },
  { to: "/admin/products", label: "מוצרים" },
  { to: "/admin/content", label: "תוכן האתר" },
  { to: "/admin/tours", label: "סיורים" },
  { to: "/admin/coupons", label: "קופונים" },
  { to: "/admin/checks", label: "בדיקות" },
  { to: "/admin/users", label: "מנהלים" },
  { to: "/admin/audit", label: "יומן" },
];

export function AdminLayout() {
  const { data } = useQuery({ queryKey: ["me"], queryFn: api.me });
  const qc = useQueryClient();

  const onLogout = async () => {
    await api.logout();
    qc.clear();
    // Also end the xhostd SSO sign-in; otherwise the next "login" click goes
    // straight back in without asking which Google account.
    window.location.assign("/xhost-auth/logout?return_to=/admin/login");
  };

  return (
    <div className="min-h-screen bg-muted/30">
      <header className="bg-card border-b">
        <div className="container flex items-center justify-between h-14">
          <Link to="/admin" className="font-serif font-bold text-primary">
            ניהול · כרם נבות
          </Link>
          <div className="flex items-center gap-2 text-sm">
            <span className="text-muted-foreground">{data?.admin?.email}</span>
            <Button variant="outline" size="sm" onClick={onLogout}>התנתק</Button>
          </div>
        </div>
        <nav className="container flex gap-4 overflow-x-auto border-t" aria-label="ניהול">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                cn("py-3 text-sm font-medium border-b-2 border-transparent hover:text-primary",
                  isActive && "border-primary text-primary")
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="container py-6">
        <Outlet />
      </main>
    </div>
  );
}
